<script setup lang="ts">
import { useDateRangeFilter } from "@/composables/filters/date-range-filter";
import { inject } from "vue";
import type { PagingFilter } from "@/composables/filters/paging-filter";
import { pagingFilterSymbol } from "@/plugins/ContentFiltersPlugin";
import { marketHolidayDates } from "@tmi/utils/date-time";

const {
  datesFilter,
  defaultFinalJSDate
} = useDateRangeFilter();

function disabledDate( date: Date ): boolean {
  return date > defaultFinalJSDate;
}

const JSDateSunday = 0;
const JSDateSaturday = 6;
const disabledDayOfWeek: number[] = [ JSDateSunday, JSDateSaturday ];

const pagingFilter = inject< PagingFilter >( pagingFilterSymbol ) as PagingFilter;
function resetPageNumber() {
  pagingFilter?.resetPageNumber();
}
</script>

<template>
  <DatePicker
      @date-select="resetPageNumber"
      v-model="datesFilter"
      :disabled-dates="marketHolidayDates"
      :disabled-days="disabledDayOfWeek"
      dateFormat="m/d/yy"
      selectionMode="range"
      placeholder="Filter by Published Date"
      class="w-full"
      showIcon
      hideOnRangeSelection
  />
</template>
